'use client'

import { useEffect, useLayoutEffect } from 'react'
import getUserLocale from 'get-user-locale'
import { localeMap } from '@/shared/utils/directus'

export function handleEsc(event) {
  if (event.key === 'Escape' || event.keyCode === 27) {
    this?.()
  }
}

export const useEscHandler = callback => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    if (!callback) return undefined
    const handleEscWithCallback = handleEsc.bind(callback)
    document.addEventListener('keydown', handleEscWithCallback)

    return () => document.removeEventListener('keydown', handleEscWithCallback)
  }, [callback])
}

export function useNoScroll(isOpen) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
    }
  }, [isOpen])
}

export const variantList = {
  visible: {
    opacity: 1,
    translateY: 0,
    transition: { duration: 0.42, delay: 0.2 },
  },
  hidden: { opacity: 0, translateY: 25 },
}

export const useVH = () => {
  useLayoutEffect(() => {
    if (!window) return undefined

    let vh = window.innerHeight * 0.01

    let isPortrait = vh * 100 > window.innerWidth

    document.documentElement.style.setProperty('--vh', `${vh}px`)
    document.documentElement.style.setProperty('--fsvh', `${vh}px`)

    const handleResize = () => {
      vh = window.innerHeight * 0.01
      const isPortraitNew = vh * 100 > window.innerWidth

      document.documentElement.style.setProperty('--vh', `${vh}px`)

      if (isPortraitNew !== isPortrait) {
        document.documentElement.style.setProperty('--fsvh', `${vh}px`)
        isPortrait = isPortraitNew
      }
    }

    return () => window.removeEventListener('resize', handleResize)
  }, [])
}

export function mapValue(x, in_min, in_max, out_min, out_max) {
  return ((x - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min
}

export function getCSSCustomPropertyValue(propertyName) {
  return getComputedStyle(document.documentElement).getPropertyValue(propertyName)
}

export function callCallbackWithDelay(callback, delayMs, times) {
  let count = 0

  function recursiveCall() {
    if (count < times) {
      callback()
      count++
      setTimeout(recursiveCall, delayMs)
    }
  }

  recursiveCall()
}

const options = {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
}

// Получаем текущую локаль пользователя
export const userLocale = getUserLocale()

// Создаем экземпляр Intl.DateTimeFormat для текущей локали
export const formatter = new Intl.DateTimeFormat('ru', options)

export function getDateLabel({ date, locale }) {
  const currentDate = new Date(date)

  const dayOfMonth = currentDate.toLocaleString(localeMap[locale], {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  })

  return `${dayOfMonth}`
}
